import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { initialDataDetail, initialDataList } from '@interfaces/common/common.Interface'

export interface CommonAppState {
  chiNhanhList?: any
  chiNhanhDetail?: any
  duAnList?: any
  duAnDetail?: any
  heThongList?: any
  heThongDetail?: any
}

const initialState: CommonAppState = {
  chiNhanhList: initialDataList,
  chiNhanhDetail: initialDataDetail,
  duAnList: initialDataList,
  duAnDetail: initialDataDetail,
  heThongList: initialDataList,
  heThongDetail: initialDataDetail,
}

export const commonAppDucks = createSlice({
  name: 'commonApp',
  initialState,
  reducers: {
    // ChiNhanh reducers
    getListChiNhanh: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhList = { loading: true, queryStr: action.payload }
    },
    getListChiNhanhSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhList = { loading: false, ...action.payload }
    },
    getListChiNhanhFail: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhList = { loading: false, ...action.payload }
    },
    getDetailChiNhanh: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhDetail = { loading: true, id: action.payload }
    },
    getDetailChiNhanhSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhDetail = { loading: false, ...action.payload }
    },
    getDetailChiNhanhFail: (state: RootState, action: PayloadAction<any>) => {
      state.chiNhanhDetail = { loading: false, ...action.payload }
    },
    // DuAn reducers
    getListDuAn: (state: RootState, action: PayloadAction<any>) => {
      state.duAnList = { loading: true, queryStr: action.payload }
    },
    getListDuAnSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.duAnList = { loading: false, ...action.payload }
    },
    getListDuAnFail: (state: RootState, action: PayloadAction<any>) => {
      state.duAnList = { loading: false, ...action.payload }
    },
    getDetailDuAn: (state: RootState, action: PayloadAction<any>) => {
      state.duAnDetail = { loading: true, id: action.payload }
    },
    getDetailDuAnSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.duAnDetail = { loading: false, ...action.payload }
    },
    getDetailDuAnFail: (state: RootState, action: PayloadAction<any>) => {
      state.duAnDetail = { loading: false, ...action.payload }
    },

    // HeThong reducers
    getListHeThong: (state: RootState, action: PayloadAction<any>) => {
      state.heThongList = { loading: true, queryStr: action.payload }
    },
    getListHeThongSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.heThongList = { loading: false, ...action.payload }
    },
    getListHeThongFail: (state: RootState, action: PayloadAction<any>) => {
      state.heThongList = { loading: false, ...action.payload }
    },
    getDetailHeThong: (state: RootState, action: PayloadAction<any>) => {
      state.heThongDetail = { loading: true, id: action.payload }
    },
    getDetailHeThongSuccess: (state: RootState, action: PayloadAction<any>) => {
      state.heThongDetail = { loading: false, ...action.payload }
    },
    getDetailHeThongFail: (state: RootState, action: PayloadAction<any>) => {
      state.heThongDetail = { loading: false, ...action.payload }
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  // ChiNhanh actions
  getListChiNhanh,
  getListChiNhanhSuccess,
  getListChiNhanhFail,
  getDetailChiNhanh,
  getDetailChiNhanhSuccess,
  getDetailChiNhanhFail,
  
  // DuAn actions
  getListDuAn,
  getListDuAnSuccess,
  getListDuAnFail,
  getDetailDuAn,
  getDetailDuAnSuccess,
  getDetailDuAnFail,
 
  // HeThong actions
  getListHeThong,
  getListHeThongSuccess,
  getListHeThongFail,
  getDetailHeThong,
  getDetailHeThongSuccess,
  getDetailHeThongFail,

} = commonAppDucks.actions

export default commonAppDucks.reducer

